import React from 'react';
import styled from '@nykaa/ui-components/styles/styled';
const originalHeight = '156px';
const Img = styled.img `
  text-align: center;
  // height: 156px;
  position: relative;
  max-height: ${({ maxHeight }) => maxHeight};
  max-width: ${({ maxWidth }) => maxWidth};
  vertical-align: middle;
`;
const Image = ({ src, alt, hasDynamicHeight, cardHeight, cardWidth, maxCardHeight, }) => (React.createElement(Img, { src: src, alt: alt, height: (hasDynamicHeight && cardHeight) ? cardHeight : originalHeight, maxWidth: (hasDynamicHeight && cardWidth) ? cardWidth : 'none', maxHeight: (hasDynamicHeight && maxCardHeight) ? maxCardHeight : originalHeight }));
export default Image;
